var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListingBedrooms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 26 41"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.5 40.5H.5V.5h25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 40.5v-37h19v37M.76.934l2.955 2.955M25.24.934l-2.955 2.955"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.47 21.429a.984.984 0 1 1-1.968 0 .985.985 0 0 1 1.969 0M17 21.5h-4"
}))));
export default SvgListingBedrooms;